import type { StorylineChartEvent, StorylineEventSentiment } from '@/mocks/marketStorylinesMock';

/** Distinct palette for GLP-1 storyline catalyst dots (one color per event). */
const GLP1_EVENT_PALETTE = [
  '#2563eb', // blue
  '#7c3aed', // violet
  '#db2777', // pink
  '#ea580c', // orange
  '#ca8a04', // amber
  '#16a34a', // green
  '#0891b2', // cyan
  '#4f46e5', // indigo
  '#c026d3', // fuchsia
  '#dc2626', // red
  '#0d9488', // teal
  '#9333ea', // purple
  '#e11d48', // rose
  '#65a30d', // lime
] as const;

const GLP1_EVENT_COLOR_INDEX: Record<string, number> = {
  '2021-06-04::Wegovy obesity approval': 0,
  '2022-04-28::SURMOUNT-1 tirzepatide data': 1,
  '2023-08-08::SELECT cardiovascular win': 2,
  '2023-10-06::Food-stock GLP-1 fears': 3,
  '2023-10-11::Dialysis-stock selloff': 4,
  '2023-11-08::Zepbound approval': 5,
  '2023-11-13::SELECT full-data / device relief': 6,
  '2024-03-05::Dialysis relief rally': 7,
  '2024-03-08::Wegovy cardiovascular label': 8,
  '2024-12-20::CagriSema disappointment / Novo crash': 9,
  '2025-04-17::Lilly oral GLP-1 upside': 10,
  '2025-07-29::Novo profit warning': 11,
  '2025-08-07::Lilly oral obesity disappointment': 12,
  '2025-11-06::U.S. pricing/access reset': 13,
};

function sentimentColor(sentiment: StorylineEventSentiment): string {
  switch (sentiment) {
    case 'positive':
      return '#10b981';
    case 'negative':
      return '#f43f5e';
    default:
      return '#6366f1';
  }
}

export function getStorylineEventColor(
  event: Pick<StorylineChartEvent, 'date' | 'label' | 'sentiment'>,
  options?: { distinct?: boolean },
): string {
  if (options?.distinct) {
    const key = `${event.date}::${event.label}`;
    const idx = GLP1_EVENT_COLOR_INDEX[key];
    if (idx != null) {
      return GLP1_EVENT_PALETTE[idx];
    }
  }
  return sentimentColor(event.sentiment);
}
